import { APPLICATION_ROUTES, Endpoint } from '@philips-emr/hpms-stipulator-commons';
import { HttpService } from '@philips-emr/tws-core/lib/services';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

function registerDinamico(): void {

  void HttpService.get<{ title: string }>(Endpoint.GET.MENU_DINAMICO)
    .then((resp) => resp.body &&
      applicationModuleRegistry.register({
        entry: 'dinamico',
        id: 'dinamico',
        name: resp.body.title,
        route: APPLICATION_ROUTES.DINAMICO,
        order: 8,
        closeable: true,
      })
    );

}
export default registerDinamico;
